import {takeLatest, all, select, put} from 'redux-saga/effects';
import {
  SAVE_PROPOSAL,
  UPDATE_QUOTATION,
  SEARCH_CUSTOMER_BY_FISCAL,
  SEARCH_CUSTOMER_BY_VAT,
} from './constants';
import {
  saveQuotationSuccess,
  saveQuotationError,
  saveProposalError,
  customerLoaded,
  customerFound,
  setUpdated
} from './actions';
import {
  makeSelectQuote,
  makeSelectProposalId,
  makeSelectCustomerCode,
  makeSelectCustomer,
  makeSelectCustomerVat,
  makeSelectCustomerContractualCategory
} from './selectors';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* saveProposal() {
  const proposal = yield select(makeSelectQuote());
  const proposalId = yield select(makeSelectProposalId());
  const requestURL = `${process.env.API_URL}proposals${(proposalId > 0) ? `/${proposalId}` : ''}`;

  try {
    const parameters = {
      method: proposalId > 0 ? 'PUT' : 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(proposal),
    };

    const response = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    if (response.data && response.data.id) {
      window.location.replace('/quotations/' + response.data.id);
    } else {
      yield put(saveProposalError(response.errors || response.data.errors || 'unknown error'));
    }
  } catch (err) {
    console.log('request error', err);
  }
}

function* updateQuotation() {
  const quote = yield select(makeSelectQuote());
  const requestURL = `${process.env.API_URL}quote/${quote.code}`;

  try {
    const parameters = {
      method: 'PUT',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(quote.customer),
    };

    const response = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    if (typeof response.data.errors !== 'undefined') {
      yield put(saveQuotationError(response.errors));
    } else {
      yield put(saveQuotationSuccess(response.data));
      yield put(setUpdated(true));
    }
  } catch (err) {
    console.log('request error', err);
  }
}

function* searchCustomerByFiscalCode() {
  const code = yield select(makeSelectCustomerCode());
  const contractualCategory = yield select(makeSelectCustomerContractualCategory());
  let customer = yield select(makeSelectCustomer());
  const requestURL = `${process.env.API_URL}customers/search?code=${code}&category=${(contractualCategory !== null ? contractualCategory : '')}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const response = yield fetch(requestURL, parameters)
                          .then(response => responseHandler(response));

    if (typeof response.error !== 'undefined') {
      if (!customer)
        customer = {}
      customer.fiscal_code = code
      customer.employee_category = contractualCategory
      yield put(customerLoaded(customer));
      yield put(customerFound(false));
    } else {
      yield put(customerLoaded(response.data));
      yield put(customerFound(true));
    }
  } catch (err) {
    yield put(customerLoaded({}));
    yield put(customerFound(false));
  }
}

function* searchCustomerByVatNumber() {
  const vat = yield select(makeSelectCustomerVat());
  const contractualCategory = yield select(makeSelectCustomerContractualCategory());
  let customer = yield select(makeSelectCustomer());
  const requestURL = `${process.env.API_URL}customers/search?vat=${vat}&category=${(contractualCategory !== null ? contractualCategory : '')}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const response = yield fetch(requestURL, parameters)
                          .then(response => responseHandler(response));

    if (typeof response.error !== 'undefined') {
      if (!customer)
        customer = {}
      customer.vat_number = vat
      customer.employee_category = contractualCategory
      yield put(customerLoaded(customer));
      yield put(customerFound(false));
    } else {
      yield put(customerLoaded(response.data));
      yield put(customerFound(true));
    }
  } catch (err) {
    yield put(customerLoaded({}));
    yield put(customerFound(false));
  }
}

function* actionWatcher() {
  yield takeLatest(SAVE_PROPOSAL, saveProposal);
  yield takeLatest(UPDATE_QUOTATION, updateQuotation);
  yield takeLatest(SEARCH_CUSTOMER_BY_FISCAL, searchCustomerByFiscalCode);
  yield takeLatest(SEARCH_CUSTOMER_BY_VAT, searchCustomerByVatNumber);
}

export default function* quotationData() {
  yield all([actionWatcher()]);
}
